import { observer } from 'mobx-react-lite';
import * as React from 'react';

import './bar.css';

interface IProps {
    volume: number;
    color: string;
}

export const Bar = observer<IProps>((props) => {
    const blocks = [];
    for (let i = 0; i < props.volume && i < 10; i++) {
        if (i === 4 && props.volume > 10) {
            blocks.push(<BarMultiBlock key={`multiblock-${i}`} color={props.color} />);
        } else {
            blocks.push(<BarBlock key={`block-${i}`} color={props.color} />);
        }
    }

    return (
        <>
            {blocks}
        </>
    );
});

interface IBlockProps {
    color: string;
}

const BarBlock = observer<IBlockProps>((props) => {
    return (
        <div className={`bar-block ${props.color}`} />
    );
});

const BarMultiBlock = observer<IBlockProps>((props) => {
    return (
        <div className='bar-block bar-multi-block'>
            <div className={`bar-multi-block-dot ${props.color}`} />
            <div className={`bar-multi-block-dot ${props.color}`} />
            <div className={`bar-multi-block-dot ${props.color}`} />
        </div>
    );
});